import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";
import { useGlobalSupplier } from "@/app/Suppliers/Utils/useGlobalSupplier";
import { GapRentalMultiTable } from "@/app/GapRentals/Components/GapRentalMultiTable";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import {
  parseRelocationTableSearch,
  relocationTableSearchFromState,
  relocationTableStateFromSearch,
} from "@/app/Relocations/Utils/relocationTableSearchParams";
import { useSearchBackedState } from "@/lib/Hooks/useSearchBackedState";

export function GapRentalTableScreen() {
  const { supplierId } = useGlobalSupplier();
  const t = useTranslations("relocation.table");
  const search = useSearch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/gap-rentals",
  });
  const navigate = useNavigate({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/gap-rentals",
  });
  const [state, setState] = useSearchBackedState({
    search,
    parseSearch: parseRelocationTableSearch,
    fromSearch: relocationTableStateFromSearch,
    writeSearch: (newState, { replace }) => {
      navigate({
        search: (old) => ({
          ...old,
          ...relocationTableSearchFromState(newState),
        }),
        replace,
      });
    },
  });

  return (
    <FullPageScreen>
      <GapRentalMultiTable
        supplierId={supplierId ?? undefined}
        tableId="gap-rentals"
        title={t("gapRentalsTitle")}
        state={state}
        onStateChange={setState}
      />
    </FullPageScreen>
  );
}
